var map = {
	"./AdGuardDnsInfo.vue": [
		62488,
		[
			2488
		]
	],
	"./AdGuardFilterStatus.vue": [
		38416,
		[
			8416
		]
	],
	"./AdGuardStats.vue": [
		56256,
		[
			2657,
			6256
		]
	],
	"./AdGuardTopDomains.vue": [
		99718,
		[
			9718
		]
	],
	"./AnonAddy.vue": [
		9600,
		[
			9600
		]
	],
	"./Apod.vue": [
		24944,
		[
			4944
		]
	],
	"./BlacklistCheck.vue": [
		75747,
		[
			5747
		]
	],
	"./Blank.vue": [
		24387,
		[
			4387
		]
	],
	"./ChuckNorris.vue": [
		24399,
		[
			4399
		]
	],
	"./Clock.vue": [
		7783,
		[
			7783
		]
	],
	"./CodeStats.vue": [
		38881,
		[
			2657,
			8881
		]
	],
	"./CovidStats.vue": [
		559,
		[
			2657,
			559
		]
	],
	"./CryptoPriceChart.vue": [
		10188,
		[
			2657,
			188
		]
	],
	"./CryptoWatchList.vue": [
		35927,
		[
			5927
		]
	],
	"./CustomList.vue": [
		98220,
		[
			8220
		]
	],
	"./CustomSearch.vue": [
		12118,
		[
			2118
		]
	],
	"./CveVulnerabilities.vue": [
		66589,
		[
			6589
		]
	],
	"./DomainMonitor.vue": [
		89954,
		[
			9954
		]
	],
	"./DroneCi.vue": [
		45364,
		[
			5364
		]
	],
	"./EmbedWidget.vue": [
		41138,
		[
			1138
		]
	],
	"./EthGasPrices.vue": [
		83319,
		[
			2657,
			3319
		]
	],
	"./ExchangeRates.vue": [
		67497,
		[
			7497
		]
	],
	"./Filebrowser.vue": [
		10335,
		[
			7809,
			335
		]
	],
	"./Flights.vue": [
		34512,
		[
			4512
		]
	],
	"./GitHubProfile.vue": [
		40387,
		[
			387
		]
	],
	"./GitHubTrending.vue": [
		37103,
		[
			7103
		]
	],
	"./GlAlerts.vue": [
		59730,
		[
			9730
		]
	],
	"./GlCompactMetrics.vue": [
		5964,
		[
			5964
		]
	],
	"./GlCpuCores.vue": [
		75429,
		[
			5429
		]
	],
	"./GlCpuGauge.vue": [
		48294,
		[
			8294
		]
	],
	"./GlCpuHistory.vue": [
		4964,
		[
			2657,
			4964
		]
	],
	"./GlCpuSpeedometer.vue": [
		59212,
		[
			9212
		]
	],
	"./GlCpuTemp.vue": [
		75048,
		[
			5048
		]
	],
	"./GlDiskIo.vue": [
		11157,
		[
			1157
		]
	],
	"./GlDiskSpace.vue": [
		18840,
		[
			8840
		]
	],
	"./GlIpAddress.vue": [
		4456,
		[
			4456
		]
	],
	"./GlLoadHistory.vue": [
		85998,
		[
			2657,
			5998
		]
	],
	"./GlMemGauge.vue": [
		58726,
		[
			8726
		]
	],
	"./GlMemHistory.vue": [
		59402,
		[
			2657,
			9402
		]
	],
	"./GlMemSpeedometer.vue": [
		97406,
		[
			7406
		]
	],
	"./GlNetworkInterfaces.vue": [
		28986,
		[
			8986
		]
	],
	"./GlNetworkTraffic.vue": [
		6203,
		[
			2657,
			6203
		]
	],
	"./GlSystemLoad.vue": [
		1175,
		[
			2657,
			1175
		]
	],
	"./GlancesUptime.vue": [
		28260,
		[
			8260
		]
	],
	"./GluetunStatus.vue": [
		16737,
		[
			9118
		]
	],
	"./HackernewsTrending.vue": [
		80226,
		[
			226
		]
	],
	"./HealthChecks.vue": [
		48149,
		[
			8149
		]
	],
	"./IframeWidget.vue": [
		67595,
		[
			7595
		]
	],
	"./ImageWidget.vue": [
		16479,
		[
			6479
		]
	],
	"./Jokes.vue": [
		4402,
		[
			4402
		]
	],
	"./Linkding.vue": [
		17524,
		[
			7524
		]
	],
	"./MinecraftStatus.vue": [
		44217,
		[
			4217
		]
	],
	"./MullvadStatus.vue": [
		3705,
		[
			3705
		]
	],
	"./Mvg.vue": [
		77640,
		[
			7640
		]
	],
	"./MvgConnection.vue": [
		92647,
		[
			2647
		]
	],
	"./NdCpuHistory.vue": [
		69091,
		[
			2657,
			9091
		]
	],
	"./NdLoadHistory.vue": [
		38415,
		[
			2657,
			8415
		]
	],
	"./NdRamHistory.vue": [
		5606,
		[
			2657,
			5606
		]
	],
	"./NewsHeadlines.vue": [
		73617,
		[
			3617
		]
	],
	"./NextcloudNotifications.vue": [
		58227,
		[
			8227
		]
	],
	"./NextcloudPhpOpcache.vue": [
		6122,
		[
			3741
		]
	],
	"./NextcloudStats.vue": [
		86908,
		[
			6908
		]
	],
	"./NextcloudSystem.vue": [
		3299,
		[
			2657,
			3299
		]
	],
	"./NextcloudUser.vue": [
		83126,
		[
			3126
		]
	],
	"./NextcloudUserStatus.vue": [
		78798,
		[
			8798
		]
	],
	"./PiHoleStats.vue": [
		37527,
		[
			2657,
			7527
		]
	],
	"./PiHoleStatsV6.vue": [
		33114,
		[
			2657,
			3114
		]
	],
	"./PiHoleTopQueries.vue": [
		80349,
		[
			349
		]
	],
	"./PiHoleTopQueriesV6.vue": [
		31683,
		[
			1683
		]
	],
	"./PiHoleTraffic.vue": [
		2323,
		[
			2657,
			2323
		]
	],
	"./PiHoleTrafficV6.vue": [
		69028,
		[
			2657,
			9028
		]
	],
	"./Proxmox.vue": [
		39827,
		[
			9827
		]
	],
	"./PublicHolidays.vue": [
		45551,
		[
			5551
		]
	],
	"./PublicIp.vue": [
		25119,
		[
			5119
		]
	],
	"./RescueTime.vue": [
		24551,
		[
			4551
		]
	],
	"./RssFeed.vue": [
		34013,
		[
			4013
		]
	],
	"./Sabnzbd.vue": [
		34462,
		[
			4462
		]
	],
	"./SportsScores.vue": [
		79919,
		[
			9919
		]
	],
	"./StatPing.vue": [
		67644,
		[
			7644
		]
	],
	"./StockPriceChart.vue": [
		66024,
		[
			2657,
			6024
		]
	],
	"./SynologyDownload.vue": [
		18622,
		[
			8622
		]
	],
	"./SystemInfo.vue": [
		63894,
		[
			2657,
			3894
		]
	],
	"./TacticalRMM.vue": [
		1483,
		[
			1483
		]
	],
	"./TflStatus.vue": [
		63635,
		[
			3635
		]
	],
	"./UptimeKuma.vue": [
		7526,
		[
			7809,
			7526
		]
	],
	"./UptimeKumaStatusPage.vue": [
		15256,
		[
			5256
		]
	],
	"./WalletBalance.vue": [
		47388,
		[
			7388
		]
	],
	"./Weather.vue": [
		4718,
		[
			4718
		]
	],
	"./WeatherForecast.vue": [
		98948,
		[
			8948
		]
	],
	"./WidgetBase.vue": [
		66072,
		[]
	],
	"./XkcdComic.vue": [
		39434,
		[
			9434
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(function() {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(function() { return __webpack_require__(id); });
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 42625;
module.exports = webpackAsyncContext;